import * as sections from 'constants/sections';
import { formConfig } from 'config/forms';

import { validateModel } from 'models/validate';

// IDENTIFICATION
import identificationNameValidator from 'forms/sections/identification/name/validate';
import identificationDateOfBirthValidator from 'forms/sections/identification/dateOfBirth/validate';
import identificationPlaceOfBirthValidator from 'forms/sections/identification/placeOfBirth/validate';
import identificationSSNValidator from 'forms/sections/identification/ssn/validate';
import identificationOtherNamesValidator from 'forms/sections/identification/otherNames/validate';
import identificationContactValidator from 'forms/sections/identification/contactInfo/validate';
import identificationPhysicalValidator from 'forms/sections/identification/physical/validate';

// HISTORY
import historyResidenceValidator from 'forms/sections/history/residence/validate';
import historyEmploymentValidator from 'forms/sections/history/employment/validate';
import historyEducationValidator from 'forms/sections/history/education/validate';
import historyFederalValidator from 'forms/sections/history/federal/validate';

// RELATIONSHIPS
import relationshipsMaritalModel from 'forms/sections/relationships/marital/validate';
import relationshipsCohabitantsValidator from 'forms/sections/relationships/cohabitants/validate';
import relationshipsPeopleModel from 'forms/sections/relationships/people/validate';
import relationshipsRelativesValidator from 'forms/sections/relationships/relatives/validate';

// CITIZENSHIP
import citizenshipUSPassportValidator from 'forms/sections/citizenship/usPassports/validate';
import citizenshipStatusValidator from 'forms/sections/citizenship/status/validate';
import citizenshipMultipleValidator from 'forms/sections/citizenship/multiple/validate';
import citizenshipForeignPassportsValidator from 'forms/sections/citizenship/foreignPassports/validate';

// MILITARY
import militaryHistoryValidator from 'forms/sections/military/history/validate';
import militarySelectiveServiceValidator from 'forms/sections/military/selectiveService/validate';
import militaryDisciplinaryProceduresValidator from 'forms/sections/military/disciplinary/validate';
import militaryForeignValidator from 'forms/sections/military/foreign/validate';

// FOREIGN
import foreignContactsValidator from 'forms/sections/foreign/contacts/validate';
import foreignActivitiesDirectValidator from 'forms/sections/foreign/activities/direct/validate';
import foreignActivitiesIndirectValidator from 'forms/sections/foreign/activities/indirect/validate';
import foreignActivitiesRealEstateValidator from 'forms/sections/foreign/activities/realEstate/validate';
import foreignActivitiesBenefitsValidator from 'forms/sections/foreign/activities/benefits/validate';
import foreignActivitiesSupportValidator from 'forms/sections/foreign/activities/support/validate';

import foreignActivitiesOnGoingSupportValidator from 'forms/sections/foreign/activities/ongoingsupport/validate';
import foreignActivitiesFutureValidator from 'forms/sections/foreign/activities/future/validate';
import foreignActivitiesCurrentValidator from 'forms/sections/foreign/activities/current/validate';

import foreignBusinessAdviceValidator from 'forms/sections/foreign/business/advice/validate';
import foreignBusinessFamilyValidator from 'forms/sections/foreign/business/family/validate';
import foreignBusinessEmploymentValidator from 'forms/sections/foreign/business/employment/validate';
import foreignBusinessConferencesValidator from 'forms/sections/foreign/business/conferences/validate';
import foreignBusinessVenturesValidator from 'forms/sections/foreign/business/ventures/validate';
import foreignBusinessSponsorshipValidator from 'forms/sections/foreign/business/sponsorship/validate';
import foreignBusinessContactValidator from 'forms/sections/foreign/business/contact/validate';
import foreignBusinessPoliticalValidator from 'forms/sections/foreign/business/political/validate';
import foreignBusinessVotingValidator from 'forms/sections/foreign/business/voting/validate';
import foreignTravel from 'forms/sections/foreign/travel/validate';

// FINANCIAL
import financialBankruptcyValidator from 'forms/sections/financial/bankruptcy/validate';
import financialGamblingValidator from 'forms/sections/financial/gambling/validate';
import financialCardAbuseValidator from 'forms/sections/financial/card/validate';
import financialTaxesValidator from 'forms/sections/financial/taxes/validate';
import financialCreditValidator from 'forms/sections/financial/credit/validate';
import financialDelinquentValidator from 'forms/sections/financial/delinquent/validate';
import financialFederalDebtValidator from 'forms/sections/financial/federaldebt/validate';
import financialNonPaymentValidator from 'forms/sections/financial/nonPayment/validate';
import financialAlimonyValidator from 'forms/sections/financial/alimony/validate';
import financialAssetSeizedValidator from 'forms/sections/financial/assetSeized/validate';
import financialChildSupportValidator from 'forms/sections/financial/childSupport/validate';
import financialCivilJudgementValidator from 'forms/sections/financial/civilJudgement/validate';
import financialEvictionValidator from 'forms/sections/financial/eviction/validate';
import financialForeclosureValidator from 'forms/sections/financial/foreclosure/validate';
import financialLienValidator from 'forms/sections/financial/lien/validate';
import financialNonpaymentNonfederalValidator from 'forms/sections/financial/nonpaymentNonfederal/validate';
import financialRepossessionValidator from 'forms/sections/financial/repossession/validate';

// SUBSTANCE
import substanceDrugInvolvementValidator from 'forms/sections/substance/purchase/validate';
import substanceDrugsUsageValidator from 'forms/sections/substance/drugs/usage/validate';
import substanceDrugsClearanceValidator from 'forms/sections/substance/drugs/clearance/validate';
import substanceDrugsPrescriptionValidator from 'forms/sections/substance/drugs/prescription/validate';
import substanceDrugSafetyUsesValidator from 'forms/sections/substance/drugs/publicSafety/validate';
import substanceDrugsVoluntaryTreatmentValidator from 'forms/sections/substance/drugs/voluntaryTreatment/validate';
import substanceDrugsMandatoryTreatmentValidator from 'forms/sections/substance/drugs/mandatoryTreatment/validate';
import substanceDrugSupplementalPublicSafetyValidator from 'forms/sections/substance/drugs/supplementalPublicSafety/validate';
import substanceDrugSupplementalUsageValidator from 'forms/sections/substance/drugs/supplementalUsage/validate';
import substanceAlcoholNegativeValidator from 'forms/sections/substance/alcohol/negative/validate';
import substanceAlcoholOrderedCounselingValidator from 'forms/sections/substance/alcohol/counseling/mandatory/validate';
import substanceAlcoholVoluntaryCounselingValidator from 'forms/sections/substance/alcohol/counseling/voluntary/validate';
import substanceAlcoholSupplementalCounselingValidator from 'forms/sections/substance/alcohol/counseling/supplemental/validate';
import substanceAlcoholReceivedCounselingValidator from 'forms/sections/substance/alcohol/additional/validate';
import substanceThcClearanceValidator from 'forms/sections/substance/thc/clearance/validate';
import substanceThcUsageValidator from 'forms/sections/substance/thc/usage/validate';
import substanceThcPublicSafetyValidator from 'forms/sections/substance/thc/publicSafety/validate';
import substanceThcInvolvementsValidator from 'forms/sections/substance/thc/purchase/validate';
// LEGAL
import legalPoliceOffenseValidator from 'forms/sections/legal/police/offense/validate';
import legalPoliceOtherOffenseValidator from 'forms/sections/legal/police/otherOffense/validate';
import legalInvestigationsHistoryValidator from 'forms/sections/legal/investigation/history/validate';
import legalPoliceDomesticViolenceValidator from 'forms/sections/legal/police/domesticViolence/validate';
import legalInvestigationsIssuesValidator from 'forms/sections/legal/investigation/issues/validate';
import legalInvestigationsDebarredValidator from 'forms/sections/legal/investigation/debarred/validate';
import legalInvestigationsRevokedValidator from 'forms/sections/legal/investigation/revoked/validate';
import legalInvestigationsForeignValidator from 'forms/sections/legal/investigation/foreign/validate';
import legalNonCriminalCourtActionsValidator from 'forms/sections/legal/court/validate';
import legalCriminalConvictionsValidator from 'forms/sections/legal/criminalconviction/validate';
import legalTechnologyUnauthorizedValidator from 'forms/sections/legal/technology/unauthorized/validate';
import legalTechnologyProtectedUnauthorizedValidator from 'forms/sections/legal/technology/protectedunauthorized/validate';
import legalTechnologyNonComplianceValidator from 'forms/sections/legal/technology/noncompliance/validate';
import legalTechnologyManipulatingValidator from 'forms/sections/legal/technology/manipulating/validate';
import legalTechnologyDenied from 'forms/sections/legal/technology/denied/validate';
import legalTechnologyUnlawful from 'forms/sections/legal/technology/unlawful/validate';
import legalAssociationsTerroristOrganizationValidator from 'forms/sections/legal/associations/terroristOrganization/validate';
import legalAssociationsTerroristOrganizationMembershipValidator from 'forms/sections/legal/associations/terroristOrganizationMembership/validate'; // PVQ
import legalAssociationsTerrorismEngagementValidator from 'forms/sections/legal/associations/terrorismEngagement/validate'; // PVQ
import legalAssociationsAdvocacyTerrorismValidator from 'forms/sections/legal/associations/TerrorismAdvocacy/validate'; // PVQ
import legalAssociationsRightsSuppressionGroupValidator from 'forms/sections/legal/associations/rightsSuppressionGroup/validate'; // PVQ
import legalAssociationsViolentRightsSuppressionGroupValidator from 'forms/sections/legal/associations/violentRightsSuppressionGroup/validate'; // PVQ
import legalAssociationsViolentOrganizationValidator from 'forms/sections/legal/associations/violentOrganization/validate'; // PVQ
import legalAssociationsViolentActsValidator from 'forms/sections/legal/associations/violentActs/validate'; // PVQ
import legalAssociationsHateCrimeAdvocacyValidator from 'forms/sections/legal/associations/hateCrimeAdvocacy/validate'; // PVQ
import legalAssociationsInternationalAndDomesticTerrorismValidator from 'forms/sections/legal/associations/internationalAndDomesticTerrorism/validate'; // PVQ
import legalAssociationsInternationalAndDomesticTerrorismEngagementValidator from 'forms/sections/legal/associations/internationalAndDomesticTerrorismEngagement/validate'; // PVQ
import legalAssociationsInternationalAndDomesticTerrorismAssociationValidator from 'forms/sections/legal/associations/internationalAndDomesticTerrorismAssociation/validate';
import legalAssociationsInternationalAndDomesticTerrorismAdvocacyValidator from 'forms/sections/legal/associations/internationalAndDomesticTerrorismAdvocacy/validate'; // PVQ
import legalAssociationsAdvocatingValidator from 'forms/sections/legal/associations/advocating/validate';
import legalAssociationsEngagedTerrorismValidator from 'forms/sections/legal/associations/engagedTerrorism/validate';
import legalAssociationsViolenceValidator from 'forms/sections/legal/associations/violence/validate';
import legalAssociationsMembershipOverthrowValidator from 'forms/sections/legal/associations/membershipOverthrow/validate';
import legalAssociationsActivities from 'forms/sections/legal/associations/activitiesOverthrow/validate';
import legalAssociationsTerrorismAssociationValidator from 'forms/sections/legal/associations/terrorismAssociation/validate';

// PSYCHOLOGICAL
import psychologicalConsultationsValidator from 'forms/sections/psychological/consultations/validate';
import pyschologicalCompetenceValidator from 'forms/sections/psychological/competence/validate';
import psychologicalHospitalizationsValidator from 'forms/sections/psychological/hospitalizations/validate';
import psychologicalDiagnosesValidator from 'forms/sections/psychological/diagnoses/validate';
import psychologicalExistingConditionsValidator from 'forms/sections/psychological/existingConditions/validate';

// PACKAGE
import packageCommentsValidator from 'forms/sections/package/comments/validate';
import substanceDrugsNegativeImpactValidator from 'forms/sections/substance/drugs/negativeImpact/validate';
import {
  requireRelationshipMaritalForeignBornDocExpiration,
  requireRelationshipMaritalDivorcePhoneNumber,
  requireRelationshipCohabitantSSN,
  requireRelationshipMaritalSSN,
  requireRelationshipRelativesForeignBornDoc,
  requireRelationshipRelativesUSResidenceDoc,
  requireMultipleCitizenshipRenounced,
  requireForeignMilitaryMaintainsContact,
  requireHistoryEmployeeSupervisorPhysicalAddress,
  requireForeignCounterIntelligence,
  requireForeignExcessiveKnowledge,
  requireForeignSensitiveInformation,
  requireForeignThreatened,
  requireFinancialBankruptcyTrusteeInformation,
  requireFinancialCardDisciplinaryDate,
  requireFinancialDelinquentName,
  requireFinancialDelinquentInfraction,
  requireDrugWhileSafety,
  requireDrugWithClearance,
  requireDrugInFuture,
  requireAlcoholOrderedCounselingParty,
  requireLegalOffenseInvolvements,
  requireLegalOffenseSentenced,
  requireLegalOffenseIncarcerated,
  requireLegalPoliceFirearms,
  requireLegalPoliceDrugs,
  requireLegalInvestigationClearanceGranted,
  requireMilitaryHasServedMerchantMarine,
  requireMilitaryCountry,
  requireMilitaryHasBeenDischarged,
  requireIdentificationContactInfo,
  requireIdentificationPhysicalHeight,
  requireIdentificationPhysicalWeight,
  requireIdentificationPhysicalEyeColor,
  requireIdentificationPhysicalHairColor,
  requireRelationshipsPeopleName2013,
  requireRelationshipsPeopleRelationship,
  requireRelationshipsPeopleRank,
  requireRelationshipsPeopleEmail,
  requireHistoryResidenceRole,
  requireHistoryResidenceReferenceInfo,
  requireCitizenshipMultipleDates,
  requireCitizenshipMultipleCurrent,
  requireCitizenshipMultipleHow,
  requireSupervisorAddress,
  requireSupervisorHasDifferentAddress,
  requireEmploymentItemStatus,
  requireEmploymentHistorySupervisorEmail,
  requireEmploymentItemLeft,
  requireCitizenshipStatusMaidenName,
  requireCitizenshipStatusForm240Date,
  requireCitizenshipStatusForm240DateExplanation,
  requireCitizenshipStatusResidenceStatus,
  requireCitizenshipStatusNotCitizenDocumentFields,
  requireCitizenshipStatusNaturalizedFields,
  requireCitizenshipStatusCitizenshipCertificateFields,
  requireCitizenshipStatusForeignBorn,
  requireCitizenshipStatusDerived,
  requireCitizenshipStatusAlienRegistrationExpiration,
  requireHistoryResidenceReferenceName,
  requireHistoryEducationReferenceFields,
  requireRelationshipRelativesAdditionalFamily,
  requireIdentificationOtherNameExplanation,
  requireEmploymentSelfEmployedJobLocation,
  requireRelationshipRelativesAPOFPOIDK,
  requireForeignContactAPOFPOIDK,
  requireCitizenshipUsPassportExpiration,
} from './branches';
import { SF86 } from '../constants/formTypes';

// Map sections to their validator classes (temporary)
export const getValidatorForSection = (subsectionKey) => {
  switch (subsectionKey) {
    case sections.IDENTIFICATION_NAME:
      return identificationNameValidator;

    case sections.IDENTIFICATION_BIRTH_DATE:
      return identificationDateOfBirthValidator;

    case sections.IDENTIFICATION_BIRTH_PLACE:
      return identificationPlaceOfBirthValidator;

    case sections.IDENTIFICATION_SSN:
      return identificationSSNValidator;

    case sections.IDENTIFICATION_OTHER_NAMES:
      return identificationOtherNamesValidator;

    case sections.IDENTIFICATION_CONTACTS:
      return identificationContactValidator;

    case sections.IDENTIFICATION_PHYSICAL:
      return identificationPhysicalValidator;

    case sections.HISTORY_RESIDENCE:
      return historyResidenceValidator;

    case sections.HISTORY_EMPLOYMENT:
      return historyEmploymentValidator;

    case sections.HISTORY_EDUCATION:
      return historyEducationValidator;

    case sections.HISTORY_FEDERAL:
      return historyFederalValidator;

    case sections.RELATIONSHIPS_STATUS_MARITAL:
      return relationshipsMaritalModel;

    case sections.RELATIONSHIPS_STATUS_COHABITANTS:
      return relationshipsCohabitantsValidator;

    case sections.RELATIONSHIPS_PEOPLE:
      return relationshipsPeopleModel;

    case sections.RELATIONSHIPS_RELATIVES:
      return relationshipsRelativesValidator;

    case sections.CITIZENSHIP_US_PASSPORT:
      return citizenshipUSPassportValidator;

    case sections.CITIZENSHIP_STATUS:
      return citizenshipStatusValidator;

    case sections.CITIZENSHIP_MULTIPLE:
      return citizenshipMultipleValidator;

    case sections.CITIZENSHIP_PASSPORTS:
      return citizenshipForeignPassportsValidator;

    case sections.MILITARY_SELECTIVE:
      return militarySelectiveServiceValidator;

    case sections.MILITARY_HISTORY:
      return militaryHistoryValidator;

    case sections.MILITARY_DISCIPLINARY:
      return militaryDisciplinaryProceduresValidator;

    case sections.MILITARY_FOREIGN:
      return militaryForeignValidator;

    case sections.FOREIGN_CONTACTS:
      return foreignContactsValidator;

    case sections.FOREIGN_ACTIVITIES_DIRECT:
      return foreignActivitiesDirectValidator;

    case sections.FOREIGN_ACTIVITIES_INDIRECT:
      return foreignActivitiesIndirectValidator;

    case sections.FOREIGN_ACTIVITIES_REAL_ESTATE:
      return foreignActivitiesRealEstateValidator;

    case sections.FOREIGN_ACTIVITIES_BENEFITS:
      return foreignActivitiesBenefitsValidator;

    case sections.FOREIGN_ACTIVITIES_FUTURE:
      return foreignActivitiesFutureValidator;

    case sections.FOREIGN_ACTIVITIES_CURRENT:
      return foreignActivitiesCurrentValidator;

    case sections.FOREIGN_ACTIVITIES_SUPPORT:
      return foreignActivitiesSupportValidator;

    case sections.FOREIGN_ACTIVITIES_ONGOINGSUPPORT:
      return foreignActivitiesOnGoingSupportValidator;

    case sections.FOREIGN_BUSINESS_ADVICE:
      return foreignBusinessAdviceValidator;

    case sections.FOREIGN_BUSINESS_FAMILY:
      return foreignBusinessFamilyValidator;

    case sections.FOREIGN_BUSINESS_EMPLOYMENT:
      return foreignBusinessEmploymentValidator;

    case sections.FOREIGN_BUSINESS_VENTURES:
      return foreignBusinessVenturesValidator;

    case sections.FOREIGN_BUSINESS_CONFERENCES:
      return foreignBusinessConferencesValidator;

    case sections.FOREIGN_BUSINESS_CONTACT:
      return foreignBusinessContactValidator;

    case sections.FOREIGN_BUSINESS_SPONSORSHIP:
      return foreignBusinessSponsorshipValidator;

    case sections.FOREIGN_BUSINESS_POLITICAL:
      return foreignBusinessPoliticalValidator;

    case sections.FOREIGN_BUSINESS_VOTING:
      return foreignBusinessVotingValidator;

    case sections.FOREIGN_TRAVEL:
      return foreignTravel;

    case sections.FINANCIAL_BANKRUPTCY:
      return financialBankruptcyValidator;

    case sections.FINANCIAL_ALIMONY:
      return financialAlimonyValidator;

    case sections.FINANCIAL_ASSET_SEIZED:
      return financialAssetSeizedValidator;

    case sections.FINANCIAL_CHILD_SUPPORT:
      return financialChildSupportValidator;

    case sections.FINANCIAL_CIVIL_JUDGEMENT:
      return financialCivilJudgementValidator;

    case sections.FINANCIAL_EVICTION:
      return financialEvictionValidator;

    case sections.FINANCIAL_FORECLOSURE:
      return financialForeclosureValidator;

    case sections.FINANCIAL_LIEN:
      return financialLienValidator;

    case sections.FINANCIAL_NONPAYMENT_NONFEDERAL:
      return financialNonpaymentNonfederalValidator;

    case sections.FINANCIAL_REPOSSESSION:
      return financialRepossessionValidator;

    case sections.FINANCIAL_GAMBLING:
      return financialGamblingValidator;

    case sections.FINANCIAL_TAXES:
      return financialTaxesValidator;

    case sections.FINANCIAL_FEDERAL_DEBT:
      return financialFederalDebtValidator;

    case sections.FINANCIAL_CARD:
      return financialCardAbuseValidator;

    case sections.FINANCIAL_CREDIT:
      return financialCreditValidator;

    case sections.FINANCIAL_DELINQUENT:
      return financialDelinquentValidator;

    case sections.FINANCIAL_NONPAYMENT:
      return financialNonPaymentValidator;

    case sections.SUBSTANCE_USE_DRUGS_USAGE:
      return substanceDrugsUsageValidator;

    case sections.SUBSTANCE_USE_DRUGS_PURCHASE:
      return substanceDrugInvolvementValidator;

    case sections.SUBSTANCE_USE_DRUGS_CLEARANCE:
      return substanceDrugsClearanceValidator;

    case sections.SUBSTANCE_USE_DRUGS_PUBLIC_SAFETY:
      return substanceDrugSafetyUsesValidator;

    case sections.SUBSTANCE_USE_CONTROLLED_ILLEGAL_USAGE:
      return substanceDrugSupplementalUsageValidator;

    case sections.SUBSTANCE_USE_CONTROLLED_EMPLOYED_ILLEGAL_USAGE:
      return substanceDrugSupplementalPublicSafetyValidator;

    case sections.SUBSTANCE_USE_DRUGS_MISUSE:
      return substanceDrugsPrescriptionValidator;

    case sections.SUBSTANCE_USE_DRUGS_NEGATIVE_IMPACT:
      return substanceDrugsNegativeImpactValidator;

    case sections.SUBSTANCE_USE_DRUGS_ORDERED:
      return substanceDrugsMandatoryTreatmentValidator;

    case sections.SUBSTANCE_USE_DRUGS_VOLUNTARY:
      return substanceDrugsVoluntaryTreatmentValidator;

    case sections.SUBSTANCE_USE_ALCOHOL_NEGATIVE:
      return substanceAlcoholNegativeValidator;

    case sections.SUBSTANCE_USE_ALCOHOL_ORDERED:
      return substanceAlcoholOrderedCounselingValidator;

    case sections.SUBSTANCE_USE_ALCOHOL_VOLUNTARY:
      return substanceAlcoholVoluntaryCounselingValidator;

    case sections.SUBSTANCE_USE_ALCOHOL_ADDITIONAL:
      return substanceAlcoholReceivedCounselingValidator;

    case sections.SUBSTANCE_USE_ALCOHOL_SUPPLEMENTAL:
      return substanceAlcoholSupplementalCounselingValidator;

    case sections.SUBSTANCE_USE_THC_USAGE:
      return substanceThcUsageValidator;

    case sections.SUBSTANCE_USE_THC_PURCHASE:
      return substanceThcInvolvementsValidator;

    case sections.SUBSTANCE_USE_THC_CLEARANCE:
      return substanceThcClearanceValidator;

    case sections.SUBSTANCE_USE_THC_PUBLIC_SAFETY:
      return substanceThcPublicSafetyValidator;

    case sections.LEGAL_POLICE_OFFENSES:
      return legalPoliceOffenseValidator;

    case sections.LEGAL_POLICE_ADDITIONAL_OFFENSES:
      return legalPoliceOtherOffenseValidator;

    case sections.LEGAL_POLICE_DOMESTIC_VIOLENCE:
      return legalPoliceDomesticViolenceValidator;

    case sections.LEGAL_INVESTIGATIONS_HISTORY:
      return legalInvestigationsHistoryValidator;

    case sections.LEGAL_INVESTIGATIONS_CLEARANCE_ISSUES:
      return legalInvestigationsIssuesValidator;

    case sections.LEGAL_INVESTIGATIONS_PIV_ISSUES:
      return legalInvestigationsIssuesValidator;

    case sections.LEGAL_INVESTIGATIONS_REVOKED:
      return legalInvestigationsRevokedValidator;

    case sections.LEGAL_INVESTIGATIONS_DEBARRED:
      return legalInvestigationsDebarredValidator;

    case sections.LEGAL_INVESTIGATIONS_FOREIGN:
      return legalInvestigationsForeignValidator;

    case sections.LEGAL_CRIMINAL_CONVICTIONS: //
      return legalCriminalConvictionsValidator;

    case sections.LEGAL_COURT:
      return legalNonCriminalCourtActionsValidator;

    case sections.LEGAL_TECHNOLOGY_UNAUTHORIZED:
      return legalTechnologyUnauthorizedValidator;

    case sections.LEGAL_TECHNOLOGY_PROTECTED_UNAUTHORIZED:
      return legalTechnologyProtectedUnauthorizedValidator;

    case sections.LEGAL_TECHNOLOGY_NONCOMPLIANCE:
      return legalTechnologyNonComplianceValidator;

    case sections.LEGAL_TECHNOLOGY_MANIPULATING:
      return legalTechnologyManipulatingValidator;

    case sections.LEGAL_TECHNOLOGY_DENIED:
      return legalTechnologyDenied;

    case sections.LEGAL_TECHNOLOGY_UNLAWFUL:
      return legalTechnologyUnlawful;

    case sections.LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION:
      return legalAssociationsTerroristOrganizationValidator;

    case sections.LEGAL_ASSOCIATIONS_TERRORIST_ORGANIZATION_MEMBERSHIP: // PVQ
      return legalAssociationsTerroristOrganizationMembershipValidator;

    case sections.LEGAL_ASSOCIATIONS_TERRORISM_ENGAGEMENT: // PVQ
      return legalAssociationsTerrorismEngagementValidator;

    case sections.LEGAL_ASSOCIATIONS_TERRORISM_ADVOCACY: // PVQ
      return legalAssociationsAdvocacyTerrorismValidator;

    case sections.LEGAL_ASSOCIATIONS_RIGHTS_SUPPRESSION_GROUP: // PVQ
      return legalAssociationsRightsSuppressionGroupValidator;

    case sections.LEGAL_ASSOCIATIONS_VIOLENT_RIGHTS_SUPPRESSION_GROUP: // PVQ
      return legalAssociationsViolentRightsSuppressionGroupValidator;

    case sections.LEGAL_ASSOCIATIONS_VIOLENT_ORGANIZATION: // PVQ
      return legalAssociationsViolentOrganizationValidator;

    case sections.LEGAL_ASSOCIATIONS_VIOLENT_ACTS: // PVQ
      return legalAssociationsViolentActsValidator;

    case sections.LEGAL_ASSOCIATIONS_HATE_CRIME_ADVOCACY: // PVQ
      return legalAssociationsHateCrimeAdvocacyValidator;

    case sections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM: // PVQ
      return legalAssociationsInternationalAndDomesticTerrorismValidator;

    case sections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ENGAGEMENT: // PVQ
      return legalAssociationsInternationalAndDomesticTerrorismEngagementValidator;

    case sections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ASSOCIATION: // PVQ
      return legalAssociationsInternationalAndDomesticTerrorismAssociationValidator;

    case sections.LEGAL_ASSOCIATIONS_INTERNATIONAL_AND_DOMESTIC_TERRORISM_ADVOCACY: // PVQ
      return legalAssociationsInternationalAndDomesticTerrorismAdvocacyValidator;

    case sections.LEGAL_ASSOCIATIONS_ENGAGED_IN_TERRORISM:
      return legalAssociationsEngagedTerrorismValidator;

    case sections.LEGAL_ASSOCIATIONS_ADVOCATING:
      return legalAssociationsAdvocatingValidator;

    case sections.LEGAL_ASSOCIATIONS_MEMBERSHIP_OVERTHROW:
      return legalAssociationsMembershipOverthrowValidator;

    case sections.LEGAL_ASSOCIATIONS_MEMBERSHIP_VIOLENCE:
      return legalAssociationsViolenceValidator;

    case sections.LEGAL_ASSOCIATIONS_ACTIVITIES_TO_OVERTHROW:
      return legalAssociationsActivities;

    case sections.LEGAL_ASSOCIATIONS_TERRORISM_ASSOCIATION:
      return legalAssociationsTerrorismAssociationValidator;

    case sections.PSYCHOLOGICAL_COMPETENCE:
      return pyschologicalCompetenceValidator;

    case sections.PSYCHOLOGICAL_CONSULTATIONS:
      return psychologicalConsultationsValidator;

    case sections.PSYCHOLOGICAL_HOSPITALIZATIONS:
      return psychologicalHospitalizationsValidator;

    case sections.PSYCHOLOGICAL_DIAGNOSES:
      return psychologicalDiagnosesValidator;

    case sections.PSYCHOLOGICAL_CONDITIONS:
      return psychologicalExistingConditionsValidator;

    case sections.REVIEW_AND_SUBMIT_COMMENTS:
      return packageCommentsValidator;

    default:
      console.warn(`Validator for ${subsectionKey} section not found`);
      return null;
  }
};

export const getValidationOptionsForForm = (formType, subsectionKey, options) => {
  const validatorOptions = {
    formType,
    subsectionKey,
    formTypeConfig: formConfig[formType] || {},
    requireForeignBornDocExpiration: requireRelationshipMaritalForeignBornDocExpiration(formType),
    requireRelationshipMaritalDivorcePhoneNumber: requireRelationshipMaritalDivorcePhoneNumber(
      formType
    ),
    requireRelationshipCohabitantSSN: requireRelationshipCohabitantSSN(formType),
    requireRelationshipMaritalSSN: requireRelationshipMaritalSSN(formType),
    requireRelationshipRelativesForeignBornDoc: requireRelationshipRelativesForeignBornDoc(
      formType
    ),
    requireRelationshipRelativesUSResidenceDoc: requireRelationshipRelativesUSResidenceDoc(
      formType
    ),
    requireRelationshipRelativesAdditionalFamily: requireRelationshipRelativesAdditionalFamily(
      formType
    ),
    requireRelationshipRelativesAPOFPOIDK: requireRelationshipRelativesAPOFPOIDK(formType),
    requireIdentificationOtherNameExplanation: requireIdentificationOtherNameExplanation(formType),
    requireForeignBornDocumentation: !options.hasValidUSPassport,
    requireForeignContactAPOFPOIDK: requireForeignContactAPOFPOIDK(formType),
    requireHistoryEmployeeSupervisorPhysicalAddress: requireHistoryEmployeeSupervisorPhysicalAddress(
      formType
    ),
    requireCitizenshipRenounced: requireMultipleCitizenshipRenounced(formType),
    requireForeignMilitaryMaintainsContact: requireForeignMilitaryMaintainsContact(formType),
    requireForeignCounterIntelligence: requireForeignCounterIntelligence(formType),
    requireForeignExcessiveKnowledge: requireForeignExcessiveKnowledge(formType),
    requireForeignSensitiveInformation: requireForeignSensitiveInformation(formType),
    requireForeignThreatened: requireForeignThreatened(formType),
    requireFinancialBankruptcyTrusteeInformation: requireFinancialBankruptcyTrusteeInformation(
      formType
    ),
    requireFinancialCardDisciplinaryDate: requireFinancialCardDisciplinaryDate(formType),
    requireFinancialDelinquentName: requireFinancialDelinquentName(formType),
    requireFinancialDelinquentInfraction: requireFinancialDelinquentInfraction(formType),
    requireUseWhileEmployed: requireDrugWhileSafety(formType),
    requireUseWithClearance: requireDrugWithClearance(formType),
    requireUseInFuture: requireDrugInFuture(formType),
    requireInvolvementWhileEmployed: requireDrugWhileSafety(formType),
    requireInvolvementWithClearance: requireDrugWithClearance(formType),
    requireInvolvementInFuture: requireDrugInFuture(formType),
    requireAlcoholOrderedCounselingParty: requireAlcoholOrderedCounselingParty(formType),
    requireLegalOffenseInvolvements: requireLegalOffenseInvolvements(formType),
    requireLegalOffenseSentenced: requireLegalOffenseSentenced(formType),
    requireLegalOffenseIncarcerated: requireLegalOffenseIncarcerated(formType),
    requireLegalPoliceFirearms: requireLegalPoliceFirearms(formType),
    requireLegalPoliceDrugs: requireLegalPoliceDrugs(formType),
    requireLegalInvestigationClearanceGranted: requireLegalInvestigationClearanceGranted(formType),
    requireMilitaryHasServedMerchantMarine: requireMilitaryHasServedMerchantMarine(formType),
    requireMilitaryCountry: requireMilitaryCountry(formType),
    requireMilitaryHasBeenDischarged: requireMilitaryHasBeenDischarged(formType),
    requireIdentificationContactInfo: requireIdentificationContactInfo(formType),
    requireIdentificationPhysicalHeight: requireIdentificationPhysicalHeight(formType),
    requireIdentificationPhysicalWeight: requireIdentificationPhysicalWeight(formType),
    requireIdentificationPhysicalHairColor: requireIdentificationPhysicalHairColor(formType),
    requireIdentificationPhysicalEyeColor: requireIdentificationPhysicalEyeColor(formType),
    requireRelationshipsPeopleName2013: requireRelationshipsPeopleName2013(formType),
    requireRelationshipsPeopleRelationship: requireRelationshipsPeopleRelationship(formType),
    requireRelationshipsPeopleRank: requireRelationshipsPeopleRank(formType),
    requireRelationshipsPeopleEmail: requireRelationshipsPeopleEmail(formType),
    requireHistoryResidenceRole: requireHistoryResidenceRole(formType),
    requireHistoryResidenceReferenceInfo: requireHistoryResidenceReferenceInfo(formType),
    requireCitizenshipMultipleDates: requireCitizenshipMultipleDates(formType),
    requireCitizenshipMultipleCurrent: requireCitizenshipMultipleCurrent(formType),
    requireCitizenshipMultipleHow: requireCitizenshipMultipleHow(formType),
    requireSupervisorHasDifferentAddress: requireSupervisorHasDifferentAddress(formType),
    requireSupervisorAddress: requireSupervisorAddress(formType),
    requireEmploymentItemStatus: requireEmploymentItemStatus(formType),
    requireEmploymentHistorySupervisorEmail: requireEmploymentHistorySupervisorEmail(formType),
    requireEmploymentItemLeft: requireEmploymentItemLeft(formType),
    requireEmploymentSelfEmployedJobLocation: requireEmploymentSelfEmployedJobLocation(formType),
    requireCitizenshipStatusMaidenName: requireCitizenshipStatusMaidenName(formType),
    requireCitizenshipStatusForm240Date: requireCitizenshipStatusForm240Date(formType),
    requireCitizenshipStatusForm240DateExplanation: requireCitizenshipStatusForm240DateExplanation(
      formType
    ),
    requireCitizenshipStatusResidenceStatus: requireCitizenshipStatusResidenceStatus(formType),
    requireCitizenshipStatusNotCitizenDocumentFields: requireCitizenshipStatusNotCitizenDocumentFields(
      formType
    ),
    requireCitizenshipStatusNaturalizedFields: requireCitizenshipStatusNaturalizedFields(formType),
    requireCitizenshipStatusCitizenshipCertificateFields: requireCitizenshipStatusCitizenshipCertificateFields(
      formType
    ),
    requireCitizenshipStatusForeignBorn: requireCitizenshipStatusForeignBorn(formType),
    requireCitizenshipStatusDerived: requireCitizenshipStatusDerived(formType),
    requireCitizenshipStatusAlienRegistrationExpiration: requireCitizenshipStatusAlienRegistrationExpiration(formType),
    requireCitizenshipUsPassportExpiration: requireCitizenshipUsPassportExpiration(formType),
    requireHistoryResidenceReferenceName: requireHistoryResidenceReferenceName(formType),
    requireHistoryEducationReferenceFields: requireHistoryEducationReferenceFields(formType),
  };

  if (subsectionKey === sections.HISTORY_RESIDENCE) {
    validatorOptions.requireYears = formConfig[formType].HISTORY_RESIDENCE_YEARS;
  } else if (subsectionKey === sections.HISTORY_EMPLOYMENT) {
    validatorOptions.requireYears = formConfig[formType].HISTORY_EMPLOYMENT_YEARS;
    validatorOptions.recordYears = formConfig[formType].HISTORY_EMPLOYMENT_RECORD_YEARS;
  } else if (subsectionKey === sections.RELATIONSHIPS_PEOPLE) {
    validatorOptions.requireYears = formConfig[formType].RELATIONSHIPS_PEOPLE_YEARS;
  }

  return validatorOptions;
};

export const validateSection = (
  { subsectionKey = '', data = {}, options = {} },
  formType = SF86
) => {
  const validationModel = getValidatorForSection(subsectionKey);
  const formOptions = getValidationOptionsForForm(formType, subsectionKey, options);

  if (validationModel) {
    try {
      return validateModel(data, validationModel, {
        ...formOptions,
        ...options,
      });
    } catch (e) {
      console?.error?.(`Invalid validator for section ${subsectionKey}`, e); // eslint-disable-line no-unused-expressions
    }
  }

  return false;
};

export const sectionIsValid = (formSections = []) => formSections.every((s) => (s.subsections ? sectionIsValid(s.subsections) : s.isValid === true));

export const sectionIsInvalid = (formSections = []) => formSections.some((s) => (s.subsections ? sectionIsInvalid(s.subsections) : s.isValid === false));
